import type { NormalizeOAS, OASOutput, OASRequestParams } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';
import { Name, UserRole } from '../../types/Users';

type O = NormalizeOAS<typeof openapi>;
type RequestParams = OASRequestParams<O, '/api/team/members', 'put'>;
type ResponseBody = OASOutput<O, '/api/team/members', 'put'>;

type Params = {
  userId: number;
  newRole?: UserRole;
  name?: Name;
  hasAcceptedInvite?: boolean | null;
  hasGivenMarketingConsent?: boolean | null;
};

type Result = {
  userId: number;
};

export const editTeamMemberFactory = (apiClient: ApiClient) => {
  const editTeamMember = async (variables: Params) => {
    const requestBody = mapInputToRequestBody(variables);
    const response = await apiClient['/api/team/members'].put(requestBody);
    const responseBody = await response.json();

    return mapResponseToResult(responseBody);
  };

  const mapInputToRequestBody = (input: Params): RequestParams => {
    return {
      json: {
        userId: input.userId,
        newRole: input.newRole ?? null,
        name: input.name ?? null,
        hasAcceptedInvite: input.hasAcceptedInvite ?? null,
        hasGivenMarketingConsent: input.hasGivenMarketingConsent ?? null,
      },
    };
  };

  const mapResponseToResult = (response: ResponseBody): Result => {
    return {
      userId: response,
    };
  };

  return editTeamMember;
};
